"use client";

import { useSearchParams } from "next/navigation";
import { Suspense } from "react";

type Props = {
  paramName: string;
  paramVal: string | null;
  className?: string;
  children: React.ReactNode;
};

function Border({ paramName, paramVal, className, children }: Props) {
  const searchParams = useSearchParams();
  const param = searchParams.get(paramName);

  return (
    <div
      className={`${
        param === paramVal ? "border-accent bg-accent" : "border-secondary hover:bg-secondary"
      } border rounded-md flex items-center justify-center link link-hover ${className}`}
    >
      {children}
    </div>
  );
}

export function BorderOnSearchParam(props: Props) {
  return (
    <Suspense
      fallback={
        <div className={`border rounded-md flex items-center justify-center link link-hover ${props.className}`}>
          {props.children}
        </div>
      }
    >
      <Border {...props} />
    </Suspense>
  );
}
